import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { selectors as localeSelectors } from "../../../../redux/locale";
import { actions as userActions } from "../../../../redux/user";
import Checkmark from "../../../components/icons/Checkmark";
import { LeftLarge } from "../../../components/icons/Chevron";
import { Button, Select } from "@vitalsource/vstui";
import { ninja } from "@vitalsource/vstui/colors";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import { t } from "../../../core/translate";

const MobileList = styled.ul`
  background-color: ${ninja.getShade(11)};
  height: 100vh;
  list-style: none;
  margin: 0;
  overflow: auto;
  padding: 0;

  li {
    width: ${props => props.width}px;
  }
`;

const List = styled.ul`
  background-color: ${ninja.getShade(11)};
  color: black;
`;

const StyledButton = styled.button`
  background-color: ${ninja.getShade(11)};
  border: none;
  color: ${props =>
    props.selected ? props.theme.color.primary.getShade(7) : "white"};
  display: flex;
  padding: 12px 6px 12px 0;
  width: 100%;

  svg {
    margin-left: auto;
  }
`;

const Flag = styled.div`
  background-image: ${props => `url('${props.image}')`};
  background-position: 10px center;
  background-repeat: no-repeat;
  height: 16px;
  width: 40px;
`;

const Header = styled.h2`
  background-color: ${ninja.getShade(10)};
  color: white;
  svg {
    transform: rotate(90deg);
  }
`;

const BackButton = createThemedComponent(Button, {
  Button_minHeight_medium: 44
});

class Language extends Component {
  constructor(props) {
    super(props);
    this.setLocale = props.setLocale.bind(this, props.langKey);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    event.preventDefault();
    this.setLocale();
  }

  render() {
    const { children, image, selected } = this.props;
    return (
      <li>
        <StyledButton
          selected={selected}
          aria-current={selected}
          onClick={this.onClick}
        >
          <Flag image={image} />
          {children}
          {selected && <Checkmark />}
        </StyledButton>
      </li>
    );
  }
}

const MobileLanguages = ({
  close,
  width,
  languages,
  currentLanguage,
  setLocale
}) => {
  return (
    <div>
      <Header>
        <BackButton
          iconStart={<LeftLarge color="white" />}
          label={t("base.back", "Go back")}
          naked
          onClick={close}
        />
        {t("base.language-choice", "Language")}
      </Header>
      <MobileList width={width}>
        {languages.map(language => (
          <Language
            image={language.img}
            key={language.short}
            langKey={language.short}
            selected={currentLanguage.short === language.short}
            setLocale={setLocale}
          >
            {language.long}
          </Language>
        ))}
      </MobileList>
    </div>
  );
};

class Languages extends Component {
  constructor() {
    super();
    this.setLocale = this.setLocale.bind(this);
  }

  setLocale(e) {
    this.props.setLocale(e.currentTarget.value);
  }

  render() {
    if (this.props.isSmall) {
      return <MobileLanguages {...this.props} />;
    }

    return (
      <Select
        id="select-language-select"
        value={this.props.currentLanguage.short}
        onChange={this.setLocale}
        label={t("base.language-choice", "Language Choice")}
        labelHidden
      >
        {this.props.languages.map(language => (
          <option key={language.short} value={language.short}>
            {language.long}
          </option>
        ))}
      </Select>
    );
  }
}

const mapStateToProps = state => ({
  currentLanguage: localeSelectors.getCurrentLanguage(state),
  languages: localeSelectors.getLanguages()
});

const mapDispatchToProps = dispatch => ({
  setLocale: locale => dispatch(userActions.setLocale(locale))
});

export default connect(mapStateToProps, mapDispatchToProps)(Languages);
